// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"5e6a06c9","280":"12f6a93b","787":"d7ece244","860":"546738e0","913":"7db1d957"}[chunkId] + ".chunk.js";
};